import gsap from "gsap";

import { Component } from "../extends";
import { formatNumberWithSeperator } from "./../utils/math";

export default () =>
	class Stats extends Component() {
		mounted() {
			this.count = 0;

			this.numbers = [
				...this.el.querySelectorAll(
					".c-stats__stat .c-stat__value-number"
				),
			];
		}

		animations() {
			const timeline = gsap.timeline({
				scrollTrigger: {
					trigger: this.el,
					toggleActions: "restart none none none",
				},
			});

			this.numbers.forEach((el) => {
				const target = { val: 0 };
				const value = el.getAttribute("data-number") || 0;

				timeline.to(
					target,
					{
						val: value,
						ease: "sine.out",
						duration: 1.2,
						onUpdate() {
							el.innerText = formatNumberWithSeperator(
								Math.round(parseInt(target.val, 10))
							);
						},
						onComplete() {
							el.innerText = formatNumberWithSeperator(value);
						},
					},
					0
				);
			});
		}
	};
